export type Faq = {
  id: string;
  questionKey: string;
  answerKey: string;
};

export const faq: Faq[] = [
  {
    id: 'real',
    questionKey: 'faq.real.question',
    answerKey: 'faq.real.answer',
  },
  {
    id: 'changed',
    questionKey: 'faq.changed.question',
    answerKey: 'faq.changed.answer',
  },
  {
    id: 'server',
    questionKey: 'faq.server.question',
    answerKey: 'faq.server.answer',
  },
  {
    id: 'publish',
    questionKey: 'faq.publish.question',
    answerKey: 'faq.publish.answer',
  },
  {
    id: 'court',
    questionKey: 'faq.court.question',
    answerKey: 'faq.court.answer',
  },
  {
    id: 'better',
    questionKey: 'faq.better.question',
    answerKey: 'faq.better.answer',
  },
];
